export default __webpack_public_path__ + "static/media/6685A.c1edf96d.png";